<template>
  <app-warp title='门店后台' color='#efefef' padding='true'>
    <template #app-content>
      <div class="navListBox width100">
        <div class="headBgImg s_po_re p-b-20" style='background:linear-gradient(90deg, #E2F4FF 0%, #DFE7FF 100%);'>
          <div class="s_flex_bian_c width100 p-20">
            <div class="s_flex_ali">
              <img class="width-60 height-60" src="@/assets/images/user.png" alt="">
              <div class="m-l-10">
                <p class="fz-16 s_font_b s_c333">店员-张三</p>
                <p class="s_c9d m-t-5 fz-13 ">级别：品牌旗舰店</p>
              </div>
            </div>
            <div class="s_flex_center s_cfff width-100 height-35" style="background: linear-gradient(270deg, #5DB1FF 0%, #6A78FF 100%);border-radius: 20px;">
              <ScanOutlined />
              扫码核销
            </div>
          </div>
          <div class="s_flex_bian_c p-b-20" v-show="is_show_guide">
            <div class="width33 text-ac">
              <p class="fz-18 s_font_b">12345</p>
              <p class="s_c666 fz-13">扫码次数</p>
            </div>
            <div class="width33 text-ac">
              <p class="fz-18 s_font_b">1234</p>
              <p class="s_c666 fz-13">中奖积分</p>
            </div>
            <div class="width33 text-ac">
              <p class="fz-18 s_font_b">1234.00</p>
              <p class="s_c666 fz-13">中将红包</p>
            </div>
          </div>
        </div>
        <div class="s_po_re p-t-10 s_bf p-l-10 p-r-10" style="top:-20px;left:50%;transform: translateX(-50%);border-top-left-radius: 10px;border-top-right-radius: 10px;">
          <div class="s_flex_wrap s_flex_bian_c p-b-10 p-t-10" style="border-bottom:1px solid #EEEEEE;" v-show="is_show_order">
            <div class=" s_flex_center s_flex_fdc flex_1">
              <cIcon type="dfh" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">待发货</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="dhx" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">待核销</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="dtk" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">待退款</p>
            </div>
            <div class="s_flex_center s_flex_fdc flex_1">
              <cIcon type="qbdd" size="28" /> 
              <p class="s_c333 text-ac fz-13 m-t-5">全部订单</p>
            </div>
          </div>
          <div v-for='item in homeList' :key='item.id'>
            <div style="border-bottom:1px solid #EEEEEE;" v-show="item.children.filter(v=>v.checked).length>0">
              <p class="m-b-15 fz-15 p-t-15 s_c333 s_font_b">{{item.menu_name}}</p>
              <div class="s_flex_wrap  s_flex_ali">
                <template v-for='items in item.children' :key='items.id'>
                  <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-show="items.checked">
                    <cIcon :type="items.icon" size="28" />
                    <p class="s_c333 text-ac fz-12 m-t-5">{{items.menu_name}}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="p-t-35 p-b-35" v-show="allHide">
            <a-empty
              :image="require('@/assets/images/original.png')"
              :image-style="{
                height: '80px',
              }"
            >
            <template #description>
              <span class="s_c999">暂未勾选任何菜单</span>
            </template>
            </a-empty>
          </div>
        </div>
      </div>
      <div class="height-50 s_bf width100 s_flex_bian_c s_bor_t_cd9 s_po_ab_bl">
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="sy_1" size="20" />首页
        </p>
        <!-- <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="dgsc" size="20" />商城
        </p> -->
        <p class="height-45 s_flex_center width33 s_flex_fdc">
          <cIcon type="wd" size="20" />我的
        </p>
      </div>
    </template>
    <template #app-sider>
      <div class="m-b-20 p-l-24 p-t-20" v-show="is_show_order_form">
        订单管理：
        <a-radio-group v-model:value="is_show_order">
          <a-radio :value="1">显示</a-radio>
          <a-radio :value="0">隐藏</a-radio>
        </a-radio-group>
      </div>
      <div class="m-b-20 p-l-24" v-show="is_show_guide_form">
        导购数据：
        <a-radio-group v-model:value="is_show_guide">
          <a-radio :value="1">显示</a-radio>
          <a-radio :value="0">隐藏</a-radio>
        </a-radio-group>
      </div>
      <div class="moduleContent m-l-24 width95 m-t-20">
        <a-tabs>
          <a-tab-pane :tab="v.menu_name" v-for="v in homeList" :key="v.id">
            <div class="s_flex_wrap s_flex_ali m-t-20">
              <div class="m-b-20 width20 s_flex_center s_flex_fdc" v-for='items in v.children' :key='items.id'>
                <cIcon :type="items.icon" size="28" class="m-b-5" />
                <a-checkbox v-model:checked="items.checked" @change="checkAllHide"><span class="s_c333">{{items.menu_name}}</span></a-checkbox>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <a-button class="width-100 m-l-24 m-t-24" type="primary" v-has:clerkHomeTemplateSet="setHomeData">保存</a-button>
    </template>
  </app-warp>
</template>
<script>
  import { ScanOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getStoreClerkTemplateMenu,setStoreClerkTemplateMenu } from "@/api/clerk";
  import cIcon from "./c-icon";
  export default {
    components: { ScanOutlined, cIcon },
    setup(props) {
      const state = reactive({
        is_show_order:1,
        is_show_order_form:1,
        is_show_guide_form:0,
        is_show_guide:0,
        allHide:true,
        homeList: [
          {
            name: "云店管理",
            children: [
              {
                name: "云店订单",
                icon: "yddd",
                checked: false,
                url: "/pages/order/order_list",
              },
              {
                name: "社交电商",
                icon: "sjds",
                checked: false,
                url: "/pages/distribution_center/index",
              },
              {
                name: "直播海报",
                icon: "zbhb",
                checked: false,
                url: "/pages/live/index",
              },
              {
                name: "秒杀海报",
                icon: "mshb",
                checked: false,
                url: "/pages/seckill/index",
              },
              {
                name: "拼团海报",
                icon: "pthb",
                checked: false,
                url: "/pages/group/index",
              },
            ],
          },
          {
            name: "人员管理",
            children: [
              {
                name: "我的客户",
                icon: "wdkh",
                checked: false,
                url: "/pages/customer/customer",
              },
              {
                name: "我的业绩",
                icon: "dyyj",
                checked: false,
                url: "/pages/clerk/clerk_grades_customer",
              },
            ]
          },
          {
            name: "核销管理",
            children: [
              {
                name: "核销记录",
                icon: "hxjl",
                checked: false,
                url: "/pages/order/order_write",
              },
              {
                name: "店铺核销码",
                icon: "dphxm",
                checked: false,
                url: "/pages/placeAnOrder/index",
								type: 'click'
              },
              {
                name: "权益卡礼品",
                icon: "qyklp",
                checked: false,
                url: "/pages/rightsCard/rightsCardLog",
              },
            ]
          },
          {
            name: "超级导购",
            children: [
              {
                name: "扫码领奖",
                icon: "smlj",
                checked: false,
                url: "/pages/guide/index",
								type:'qrcode'
              },
              {
                name: "扫码奖项明细",
                icon: "smjxmx",
                checked: false,
                url: "/pages/guide/awardDetails",
              },
              {
                name: "扫码积分",
                icon: "smjf",
                checked: false,
                url: "/pages/guide/scanIntegral",
              },
            ]
          }
        ]
      });
      const checkAllHide = () =>{
        state.allHide = true
        state.homeList.forEach(v=>{
          v.children.forEach(k=>{
            if(k.checked){
              state.allHide = false
            }
          })
        })
      }
      const setHomeData = async () => {
        const hide = message.loading('正在加载中...', 0);
        var menu_ids = [];
        state.homeList.forEach(v=>{
          if(v.children.filter(s=>s.checked).length){
            menu_ids.push(v.id)
          }
          v.children.forEach(k=>{
            if(k.checked){
              menu_ids.push(k.id)
            }
          })
        })
        let result = await setStoreClerkTemplateMenu({guide_menu_is_show:state.is_show_guide,order_menu_is_show:state.is_show_order,menu_ids:menu_ids}).then((res) => res.data).catch(error=>error);
        setTimeout(hide);
        if (iscode(result)) {
          getHomeData();
          message.success(result.msg);
        } else {
          message.error(result.msg);
        }
      };
      const getHomeData = async () => {
        let result = await getStoreClerkTemplateMenu().then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          state.homeList = result.data.home_menu_list;
          state.is_show_order_form = result.data.order_menu.is_show;
          state.is_show_order = result.data.order_menu.checked;
          state.is_show_guide_form = result.data.guide_menu.is_show;
          state.is_show_guide = result.data.guide_menu.checked;
          checkAllHide();
        } else {
          message.error(result.msg);
        }
      };
      onMounted(() => {
        getHomeData();
      });
      return {
        ...toRefs(state),
        setHomeData,
        checkAllHide
      };
    },
  };
</script>
<style lang="less" scoped>
  .moduleContent {
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 20px 10px 40px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;
  }

  .headBgImg {
    background-size: cover;
  }

  .navListBox {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 45px;
    overflow-y: scroll;
  }
</style>